import React, { useState, useEffect } from 'react';
import { Trophy, LogOut, BookOpen, Medal, Award, TrendingUp, Menu, X } from 'lucide-react';
import './StudentHeaderV2.css';
import ProfileAvatar from './ProfileAvatar';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const StudentHeaderV2 = () => {
  const { user, logoutUser } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const gradeLabel = user?.grade?.name || 'Grade ' + (user?.gradeId || '?');
  const points = user?.points || 0;
  const username = user?.username?.split('.')[0] || 'Explorer';

  const navTo = (path) => {
    setIsSidebarOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    setIsSidebarOpen(false);
    logoutUser();
    window.location.href = "/login";
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    // Cleanup if component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [isSidebarOpen]);

  return (
    <header className="sh-v2-wrapper">
      
      <div className="sh-v2-profile-group">
        <ProfileAvatar username={user?.username} />
        <div className="sh-v2-greeting-col">
          <div className="sh-v2-greeting-row">
            <h2 className="sh-v2-name">{username}</h2>
            <div className="sh-v2-grade-badge">
              <BookOpen size={13} />
              <span>{gradeLabel}</span>
            </div>
          </div>
          <span className="sh-v2-subtitle">Ready for your next lesson?</span>
        </div>
      </div>

      <div className="sh-v2-mobile-controls">
        <button 
          type="button" 
          className="sh-v2-btn sh-v2-points-btn" 
          onClick={() => navTo('/student/learning-journey')}
        >
          <Trophy className="sh-v2-icon" size={18} />
          <span>{points}</span>
        </button>

        <button 
          type="button" 
          className="sh-v2-hamburger"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <div 
        className={`sh-v2-backdrop ${isSidebarOpen ? 'is-open' : ''}`}
        onClick={() => setIsSidebarOpen(false)}
      />

      <nav className={`sh-v2-nav ${isSidebarOpen ? 'is-open' : ''}`}>
        
        <button type="button" className="btn accent-outline-btns" onClick={() => navTo('/student/home')}>
          <BookOpen className="sh-v2-icon" size={18} />
          <span>Study</span>
        </button>

        <button type="button" className="btn accent-outline-btns" onClick={() => navTo('/student/progress')}>
          <TrendingUp className="sh-v2-icon" size={18} />
          <span>Performance</span>
        </button>

        <button type="button" className="btn accent-outline-btns" onClick={() => navTo('/trophy-room')}>
          <Award className="sh-v2-icon" size={18} />
          <span>Badges</span>
        </button>

        <button type="button" className="btn accent-outline-btns" onClick={() => navTo('/leaderboards')}>
          <Medal className="sh-v2-icon" size={18} />
          <span>Leaderboard</span>
        </button>

        <button 
          type="button" 
          className="sh-v2-btn sh-v2-points-btn sh-v2-desktop-only" 
          onClick={() => navTo('/student/learning-journey')}
        >
          <Trophy className="sh-v2-icon" size={18} />
          <span>{points}</span>
        </button>

        <button type="button" className="btn accent-btns" onClick={handleLogout}>
          <LogOut size={18} />
          <span>Logout</span>
        </button>
        
      </nav>
    </header>
  );
};

export default StudentHeaderV2;